// extracted by mini-css-extract-plugin
export default {"editIcon":"EditIcon_editIcon__LAKSV"};